{
  "blocks": [
    {
      "id": "test-amh",
      "kind": "test",
      "tags": ["amh", "testing", "her", "at-home", "pre-cycle"],
      "title": "AMH",
      "subtitle": "Anti-Müllerian hormone, usually to measure egg reserve.",
      "icon": "🩸",
      "body": {
        "testName": "Anti-Mullerian Hormone (AMH)",
        "category": "blood-marker",
        "whatItMeasures": "Gives an estimate of remaining egg supply (ovarian reserve). Higher = more eggs. Does NOT measure egg quality.",
        "howItWorks": "Simple blood test by finger-prick kit or at a lab. AMH can be done any day of your cycle because it is more stable than FSH or LH across the cycle. No fasting is usually required.",
        "quickFacts": [
          {
            "kind": "sample",
            "value": "Blood or finger-prick"
          },
          {
            "kind": "time",
            "value": "5 min draw or home kit"
          },
          {
            "kind": "pain",
            "value": "Needle or lancet pinch"
          },
          {
            "kind": "prep",
            "value": "Any cycle day; no fasting usually"
          },
          {
            "kind": "results",
            "value": "2-5 business days"
          }
        ],
        "turnaroundTime": "2-5 business days",
        "costRange": {
          "low": 40,
          "high": 150
        },
        "atHome": true,
        "labAvailable": true,
        "clinicRequired": false,
        "cycleDay": "Any cycle day. If AMH is bundled with FSH or estradiol, the appointment may be day 2-4 for those other markers.",
        "markerTiming": [
          {
            "marker": "AMH",
            "timing": "Any cycle day",
            "reason": "AMH is produced by small growing follicles and changes less across the cycle than FSH, LH, or estradiol."
          }
        ],
        "whyItMatters": [
          "AMH helps establish an ovarian reserve baseline for planning, not a direct measure of egg quality.",
          "AMH generally declines with age. It is usually more useful as a planning baseline than as a short-term optimization target.",
          "If AMH is being followed over time, many clinics repeat it around every 6 months rather than after every intervention."
        ],
        "dataPoints": ["dp-amh-level"],
        "section": "ovarian-reserve"
      },
      "sources": [
        {
          "title": "Testing and interpreting measures of ovarian reserve: a committee opinion",
          "authors": "Practice Committee of the American Society for Reproductive Medicine",
          "journal": "Fertility and Sterility",
          "year": 2020,
          "url": "https://www.asrm.org/practice-guidance/practice-committee-documents/testing-and-interpreting-measures-of-ovarian-reserve-a-committee-opinion-2020/",
          "evidenceLevel": "guideline"
        },
        {
          "title": "Age-specific serum anti-Mullerian hormone values for 17,120 women presenting to fertility centers within the United States",
          "authors": "Seifer DB, Baker VL, Leader B",
          "journal": "Fertility and Sterility",
          "year": 2011,
          "url": "https://pubmed.ncbi.nlm.nih.gov/21074758/",
          "evidenceLevel": "cohort"
        },
        {
          "title": "Age-stratified anti-Mullerian hormone (AMH) nomogram: a comprehensive cohort study including 22,920 women",
          "journal": "Frontiers in Endocrinology",
          "year": 2025,
          "url": "https://pmc.ncbi.nlm.nih.gov/articles/PMC12226283/",
          "evidenceLevel": "cohort"
        }
      ],
      "readTimeMinutes": 3
    },
    {
      "id": "dp-amh-level",
      "kind": "data-point",
      "tags": ["amh", "testing", "her"],
      "title": "AMH",
      "body": {
        "value": "Age-specific",
        "unit": "ng/mL",
        "normalRange": "Age-specific. Approx. median values (Beckman assay, Frontiers 2025 nomogram): age 25 ~3.3, age 30 ~2.5, age 35 ~1.4, age 40 ~0.5, age 42 ~0.3. Reference range depends on the lab's assay - Roche Elecsys reads ~23% lower than Beckman.",
        "interpretation": "AMH declines with age and helps establish your planning baseline. A value below the lab's age-specific lower limit may suggest diminished reserve; an unusually high value may suggest PMOS (ex PCOS). Context matters - your RE interprets this alongside AFC and age. Always compare your value to your lab's assay-specific reference range, not a generic 1.0-3.5 ng/mL range.",
        "aliases": ["AMH", "Anti-Mullerian Hormone", "Anti-Mullerian hormone"],
        "sampleTypes": ["blood"],
        "metricKey": "amh"
      }
    }
  ],
  "relationships": [
    {
      "from": "test-amh",
      "to": "dp-amh-level",
      "type": "data-for"
    }
  ],
  "localeVariants": []
}
